import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Layer 2: Capture fbclid synchronously BEFORE React renders
// Ensures fbc is available for the earliest tracking events (ViewContent)
try {
  const p = new URLSearchParams(window.location.search);
  let fbclid = p.get('fbclid');
  if (!fbclid && window.location.hash) {
    try { fbclid = new URLSearchParams(window.location.hash.substring(1)).get('fbclid'); } catch {}
  }
  if (fbclid) {
    const fbc = `fb.1.${Date.now()}.${fbclid}`;
    localStorage.setItem('_fb_fbc_backup', fbc);
    localStorage.setItem('_fb_last_fbclid', fbclid);
    try { sessionStorage.setItem('_fb_fbc_session', fbc); } catch {}
    // Bug 1.1: Use root domain for cross-subdomain cookie persistence
    let cookieDomain = '';
    try {
      const h = window.location.hostname;
      if (!/^(\d{1,3}\.){3}\d{1,3}$/.test(h) && h !== 'localhost') {
        const parts = h.split('.');
        const root = '.' + parts.slice(-2).join('.');
        if (!/\.(app|dev|github\.io|netlify\.app|vercel\.app|pages\.dev)$/i.test(root)) {
          cookieDomain = `; domain=${root}`;
        }
      }
    } catch {}
    document.cookie = `_fbc=${fbc}; path=/; max-age=7776000; SameSite=Lax${cookieDomain}`;
    // Improvement 1.6: Preserve landing URL with fbclid
    if (!sessionStorage.getItem('_fb_landing_url')) {
      try { sessionStorage.setItem('_fb_landing_url', window.location.href); } catch {}
    }
  }
} catch {}

// Layer 2: Traffic source detection backup (before React renders)
try {
  if (!sessionStorage.getItem('_traffic_source')) {
    let src = 'direct';
    const sp = new URLSearchParams(window.location.search);
    
    if (sp.has('fbclid') || localStorage.getItem('_fb_fbc_backup')) {
      src = 'facebook_paid';
    } else if (sp.has('gclid')) {
      src = 'google_paid';
    } else if (sp.get('utm_source')) {
      const us = sp.get('utm_source')!.toLowerCase();
      const um = (sp.get('utm_medium') || '').toLowerCase();
      if (us === 'google' && um === 'cpc') src = 'google_paid';
      else if (/facebook|fb|instagram|ig/.test(us)) src = 'facebook_paid';
      else src = us;
    } else if (/FBAN|FBAV|Instagram/i.test(navigator.userAgent)) {
      src = 'facebook_paid';
    } else if (document.referrer) {
      try {
        const rh = new URL(document.referrer).hostname.toLowerCase();
        if (/(\.|^)(facebook\.com|fb\.com|instagram\.com|messenger\.com|fbcdn\.net|l\.facebook\.com|lm\.facebook\.com)$/.test(rh)) {
          src = 'facebook_paid';
        } else if (/(\.|^)(google\.)/.test(rh)) {
          src = 'google_organic';
        } else if (rh !== window.location.hostname) {
          src = 'referral';
        }
      } catch {}
    } else {
      const lastFbclid = localStorage.getItem('_fb_last_fbclid');
      if (lastFbclid) src = 'facebook_paid';
    }
    
    try { sessionStorage.setItem('_traffic_source', src); } catch {}
  }
} catch {}

createRoot(document.getElementById("root")!).render(<App />);
